import type { WorkspaceKey } from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import { useEffect, useState } from 'react'
import {
  Group,
  Panel,
  Separator,
  useDefaultLayout,
} from 'react-resizable-panels'

import { useWorkspaceManagerContext } from '../../workspace/workspaceManagerContext'
import { WorkspaceDetailsPanel } from './workspaceDetails/WorkspaceDetailsPanel'
import { WorkspacesTree } from './workspacesTree/WorkspacesTree'

export const WorkspacesPanel = () => {
  const { conciseWorkspaces } = useWorkspaceManagerContext()
  const { currentWorkspaceKey } = useWorkspaceManagerContext()
  const [activeWorkspaceKey, setActiveWorkspaceKey] =
    useState<Optional<WorkspaceKey>>(currentWorkspaceKey)
  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    groupId: 'workspacesPanel',
    storage: localStorage,
  })
  const doesActiveWorkspaceExist = activeWorkspaceKey
    ? conciseWorkspaces[activeWorkspaceKey.branchKey.server]?.find(
        (workspace) =>
          workspace.name === activeWorkspaceKey.name &&
          workspace.baseBranchName === activeWorkspaceKey.branchKey.name,
      )
    : false

  useEffect(() => {
    if (!doesActiveWorkspaceExist && activeWorkspaceKey) {
      setActiveWorkspaceKey(undefined)
    }
  }, [activeWorkspaceKey, doesActiveWorkspaceExist])

  return (
    <Group
      id="workspacesPanel"
      orientation="vertical"
      defaultLayout={defaultLayout}
      onLayoutChanged={onLayoutChanged}
    >
      <Panel id="workspacesTreePanel" minSize="15%">
        <WorkspacesTree
          onSelect={setActiveWorkspaceKey}
          activeWorkspaceKey={activeWorkspaceKey}
        />
      </Panel>
      {activeWorkspaceKey && doesActiveWorkspaceExist && (
        <>
          <Separator
            id="resizeWorkspacePanelPicker"
            className="h-1.5 dark:bg-slate-700 bg-slate-300"
          />
          <Panel id="workspaceDetailsPanel" minSize="30%">
            <WorkspaceDetailsPanel
              onClose={() => setActiveWorkspaceKey(undefined)}
              workspaceKey={activeWorkspaceKey}
            />
          </Panel>
        </>
      )}
    </Group>
  )
}
